import { render, staticRenderFns } from "./Function.vue?vue&type=template&id=284bcc7a&scoped=true"
import script from "./Function.vue?vue&type=script&lang=js"
export * from "./Function.vue?vue&type=script&lang=js"
import style0 from "./Function.vue?vue&type=style&index=0&id=284bcc7a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284bcc7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('284bcc7a')) {
      api.createRecord('284bcc7a', component.options)
    } else {
      api.reload('284bcc7a', component.options)
    }
    module.hot.accept("./Function.vue?vue&type=template&id=284bcc7a&scoped=true", function () {
      api.rerender('284bcc7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/FinancialTerminal/components/Function.vue"
export default component.exports